import React, { useEffect, useRef, useState } from "react";
import { HiOutlineMegaphone } from "react-icons/hi2";
import { IoCloseOutline } from "react-icons/io5";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../Announcement/Announcement.scss";
import { Button } from "primereact/button";
import { FaPlus } from "react-icons/fa6";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import axios from "axios";
import {
  deleteAnnouncement,
  getAnnouncement,
  patchAnnouncement,
  postAnnouncement,
} from "../../Services/BackendUrl";
import DeletePopup from "../Components/DeletePopup";
import { encryptedAuth } from "../../Services/EncryptData";
import { FileUpload } from "primereact/fileupload";


const Announcement = () => {
  const MAX_FILE_SIZE = 1 * 1024 * 1024; 
  const [fetchedAnnoucement, setAnnouncements] = useState([]);
  const [showCheckboxes, setShowCheckboxes] = useState(false);
  const [selectedAnnouncements, setSelectedAnnouncements] = useState([]);
  const [createAnnounce, setCreateAnnounce] = useState(false);
  const [selectedPlace, setSelectedPlace] = useState('');
  const [showAnnouncepopup, setShowAnnouncepopup] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState();
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatusTag] = useState("");
  const [editAnnouncepopup, setEditAnnouncepopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [isSearch, setIsSearch] = useState("");
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState("");
  const createFileUploadRef = useRef(null);
  const editFileUploadRef = useRef(null);

  const handleFileSelect = (e, mode = "create") => {
    const selectedFile = e.files?.[0];
    if (!selectedFile) return;

    if (selectedFile.size > MAX_FILE_SIZE) {
      setFileError("File size must be 1MB or less.");
      setFile(null);
      if (mode === "create") {
        createFileUploadRef.current?.clear();
      } else {
        editFileUploadRef.current?.clear();
      }
      return;
    }

    setFileError("");
    setFile(selectedFile);
  };


  const fetchedAnnouncements = async () => {
    try {
      const response = await axios.get(getAnnouncement, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Encrypted ${encryptedAuth}`
        },
      });
      setAnnouncements(response.data.announcements);
    } catch (error) {
      console.error("Error fetching announcements", error);
    }
  };

  useEffect(() => {
    fetchedAnnouncements();
  },[]);

  const announcementField = [
    { field: "id", header: "S.No" },
    { field: "title", header: "Title" },
    { field: "tag", header: "Target" },
    { field: "status", header: "Status Tag" },
    { field: "action", header: "Action" },
  ];
  const places = [
    {tag: "Academy" },
    {tag: "Branches" },
  ];

  const handleCheckBoxes = () => {
    setShowCheckboxes((prev) => !prev);
    setSelectedAnnouncements([]);
  };

  const handleSubmit = async () => {
  if (fileError) return;
  if (!title.trim() || !selectedPlace || !status.trim() || !message.trim()) {
    alert("Please fill in all fields before submitting.");
    return;
  }

  try {
    const formData = new FormData();
    const announcementData = {
      title,
      message,
      tag: selectedPlace?.tag || "",
      status,
    };

    // append JSON as 'data' like in curl
    formData.append("data", JSON.stringify(announcementData));

    // append file if selected
    if (file) {
      formData.append("file", file);
    }

    await axios.post(postAnnouncement, formData, {
      headers: {
        Authorization: `Encrypted ${encryptedAuth}`,
        "Content-Type": "multipart/form-data",
      },
    });

    await fetchedAnnouncements();

    setCreateAnnounce(false);
    setTitle("");
    setMessage("");
    setStatusTag("");
    setSelectedPlace("");
    setFile(null);
    setFileError("");
  } catch (error) {
    console.error("Error creating announcement:", error);
    alert("Failed to create announcement. Check console for details.");
  }
};


  const handleChange = (e) => {
    const { name, value } = e.target;
    setSelectedRowData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdate = async () => {
  try {
    if (fileError) return;
    const { id, title, tag, message, status } = selectedRowData;

    if (!title.trim() || !tag || !status.trim() || !message.trim()) {
      alert("Please fill in all fields before updating.");
      return;
    }

    // prepare form data
    const formData = new FormData();
    const updateData = {
      title,
      message,
      tag,
      status,
    };
    formData.append("data", JSON.stringify(updateData));

    // append file only if user selected one
    if (file) {
      formData.append("file", file);
    }

    await axios.patch(`${patchAnnouncement}/${id}`, formData, {
      headers: {
        Authorization: `Encrypted ${encryptedAuth}`,
        "Content-Type": "multipart/form-data",
      },
    });

    await fetchedAnnouncements();
    setEditAnnouncepopup(false);
    setFile(null);
    setFileError("");

  } catch (error) {
    console.error("Error updating announcement:", error);
    alert("Failed to update announcement. Check console for details.");
  }
};


  const sureToDelete = (row) => {
    setShowDeletePopup(true);
    setSelectedRowData(row);
  };

  const handleDeleteSelected = async () => {
    const idsToDelete = selectedAnnouncements.map((row) => String(row.id));
    try {
      await axios.post(
        deleteAnnouncement,
        { ids: idsToDelete },
        {
          headers : {
            Authorization : `Encrypted ${encryptedAuth}`
          },
        }
      );
      fetchedAnnouncements();
      showCheckboxes(true);
      setSelectedRowData([]);
      setSelectedAnnouncements([]);
    } catch(error) {
      console.error("Error deleting announcements:", error);
    } finally {
      setShowDeletePopup(false);
    }
  };

  const handleDeleteSingle = async (row) => {
    const idToDelete = String(row.id);
    try {
      await axios.post(
        deleteAnnouncement,
        { ids: [idToDelete] },
        {
          headers: {
            Authorization : `Encrypted ${encryptedAuth}`
          },
        }
      );
      setAnnouncements((prev) =>
        prev.filter((item) => String(item.id) !== idToDelete)
      );
    } catch(error) {
      console.error("Error deleting announcement", error);
    } finally {
      setShowDeletePopup(false);
    }
  };

  const search = fetchedAnnoucement.filter((item) => {
    const search = isSearch.toLowerCase();
    return (
      item.title?.toLowerCase().includes(search) ||
      item.tag?.toLowerCase().includes(search) ||
      item.status?.toLowerCase().includes(search)
    );
  });

  return (
    <>
      <div className="announcement-container">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            background: "#7FC5FF26",
            padding: "15px",
            borderRadius: "50px",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              color: "white",
              gap: "10px",
            }}
          >
            <HiOutlineMegaphone size={40} />
            <div className="fb-title-box">Announcement</div>
          </div>
          <div
            className="searchbox-container"
            style={{ display: "flex", gap: "20px" }}
          >
            <IconField iconPosition="left">
              <InputIcon className="pi pi-search" />
              <InputText
                placeholder="Search here"
                value={isSearch}
                onChange={(e) => setIsSearch(e.target.value)}
                style={{
                  outline: "none",
                  boxShadow: "none",
                  border: "1px solid transparent",
                }}
              />
            </IconField>
            <div
              onClick={() => setCreateAnnounce(true)}
              style={{
                display: "flex",
                gap: "10px",
                padding: "10px 15px",
                background: "white",
                borderRadius: "25px",
                border: "none",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <FaPlus />
              <span>Create Announcement</span>
            </div>
          </div>
        </div>
        <div className="announcement-table-container">
          <DataTable
            value={search}
            selection={selectedAnnouncements}
            onSelectionChange={(e) => setSelectedAnnouncements(e.value)}
            selectionMode={showCheckboxes ? "multiple" : ""}
            dataKey="id"
            tableStyle={{ minWidth: "50rem" }}
            paginator
            rows={5}
            paginatorTemplate={{
              layout: "PrevPageLink PageLinks NextPageLink RowsPerPageDropdown",
              PrevPageLink: (options) => {
                return (
                  <button
                    type="button"
                    className="p-paginator-prev p-paginator-element p-link"
                    onClick={options.onClick}
                    disabled={options.disabled}
                  >
                    <i
                      className="pi pi-angle-left"
                      style={{ marginRight: "5px" }}
                    ></i>
                    Back
                  </button>
                );
              },
              NextPageLink: (options) => {
                return (
                  <button
                    type="button"
                    className="p-paginator-next p-paginator-element p-link"
                    onClick={options.onClick}
                    disabled={options.disabled}
                  >
                    Next
                    <i
                      className="pi pi-angle-right"
                      style={{ marginLeft: "5px" }}
                    ></i>
                  </button>
                );
              },
            }}
          >
            {announcementField.map((col, index) => (
              <Column
                key={index}
                field={col.field !== "action" ? col.field : undefined}
                header={col.header}
                body={
                  col.field === "id"
                    ? (rowData, options) => (
                        <span>
                          {(options.rowIndex + 1).toString().padStart(2, "0")}
                        </span>
                      )
                    : col.field === "action"
                    ? (rowData) => (
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                            marginLeft: "-30px",
                          }}
                        >
                          <Button
                            icon="pi pi-eye"
                            onClick={() => {
                              setSelectedRowData(rowData);
                              setShowAnnouncepopup(true);
                            }}
                            style={{
                              background: "#2D4A5E",
                              color: "#0AB1E9",
                              padding: "7px 3px",
                              borderRadius: "10px",
                              border: "transparent",
                            }}
                          />
                          <Button
                            icon="pi pi-trash"
                            onClick={() => sureToDelete(rowData)}
                            style={{
                              background: "#2D4A5E",
                              color: "#FF4649",
                              padding: "7px 3px",
                              borderRadius: "10px",
                              border: "transparent",
                            }}
                          />
                          <Button
                            icon="pi pi-file-edit"
                            onClick={() => {
                              setSelectedRowData(rowData);
                              setEditAnnouncepopup(true);
                            }}
                            style={{
                              background: "#2D4A5E",
                              color: "#FDDA50",
                              padding: "7px 3px",
                              borderRadius: "10px",
                              border: "transparent",
                            }}
                          />
                        </div>
                      )
                    : undefined
                }
                headerStyle={col.field === "id"}
              />
            ))}
            <Column
              selectionMode={showCheckboxes ? "multiple" : null}
              header={
                showCheckboxes ? (
                  <Button
                    icon="pi pi-trash"
                    style={{
                      color: "#FF4649",
                      padding: "3px",
                      backgroundColor: "transparent",
                      border: "transparent",
                    }}
                    onClick={() => {
                      if (selectedAnnouncements.length > 0) {
                        setShowDeletePopup(true);
                      } else {
                        setShowCheckboxes(false);

                        const updated = fetchedAnnoucement.map((c) => ({
                          ...c,
                          checkbox: false,
                          isChecked: false,
                        }));

                        setAnnouncements(updated);
                      }
                    }}
                  />
                ) : (
                  <Button
                    icon="pi pi-pencil"
                    onClick={handleCheckBoxes}
                    severity="white"
                    style={{
                      backgroundColor: "transparent",
                      border: "transparent",
                    }}
                  />
                )
              }
            />
          </DataTable>
        </div>

        {createAnnounce && (
          <div
            className="createAnnouncement"
            style={{
              position: "fixed",
              top: 0,
              bottom: 0,
              right: 0,
              left: 0,
              backgroundColor: "#00000033",
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                background: "white",
                width: "45%",
                height: "max-content",
                padding: "30px",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                marginTop: "120px",
                borderRadius: "25px",
              }}
            >
              <header
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <h2 style={{ fontWeight: "950" }}>CREATE ANNOUNCEMENT</h2>
                <IoCloseOutline
                  size={30}
                  onClick={() => {setCreateAnnounce(false); 
                    setTitle("");
                    setMessage("");
                    setStatusTag("");
                    setSelectedPlace('');
                    setFile(null);
                    setFileError("");}}
                />
              </header>
              <hr />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                    }}
                  >
                    <label>Title</label>
                    <InputText
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      style={{ width: "250px", height: "50px" }}
                      placeholder="Enter Title..."
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                    }}
                  >
                    <label>Target Section</label>
                    <Dropdown
                      style={{ width: "250px", height: "50px" }}
                      name="tag"
                      value={selectedPlace}
                      onChange={(e) => setSelectedPlace(e.value)}
                      options={places}
                      optionLabel="tag"
                      placeholder="Choose Place"
                      appendTo='self'
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                    }}
                  >
                    <label>Status Tag</label>
                    <Dropdown
                      style={{ width: "250px", height: "50px" }}
                      name="status"
                      value={status}
                      onChange={(e) => setStatusTag(e.value)}
                      options={["active", "inactive"]}
                      placeholder="Select the status"
                      appendTo='self'
                    />
                  </div>
                  <div
  style={{
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  }}
>
  <label>Upload File (optional)</label>
  <FileUpload
    ref={createFileUploadRef}
    mode="basic"
    name="file"
    accept=".pdf"
    customUpload
    auto={false}
    chooseLabel={file ? file.name : "Choose File"}
    onSelect={(e) => handleFileSelect(e, "create")}
    style={{
      background: "white",
      border: "1px solid #ccc",
      borderRadius: "10px",
      width: "250px",
      padding: "12px",
      height: "50px",
      display: "flex",
      alignItems: "center",
    }}
    chooseOptions={{
      icon: "pi pi-upload",
      className: "p-button-sm p-button-outlined p-button-secondary",
      style: {
        width: "100%",
        justifyContent: "flex-start",
        color: "#333",
        background: "white",
        border: "none",
        fontWeight: "500",
        height: "100%",
        borderRadius: "8px",
      },
    }}
  />
  {fileError && (
    <small style={{ color: "red", marginTop: "4px" }}>{fileError}</small>
  )}
</div>


                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <label>Message</label>
                  <InputTextarea
                    name="message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    rows={5}
                    cols={30}
                    style={{ width: "100%", height: "100px" }}
                  />
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  onClick={handleSubmit}
                  label="Submit"
                  style={{
                    backgroundColor: "#05B8E6",
                    color: "white",
                    padding: "10px 40px",
                    borderRadius: "25px",
                  }}
                />
              </div>
              <div></div>
            </div>
          </div>
        )}

       {showAnnouncepopup && selectedAnnouncements && (
  <div
    className="showAnnouncement"
    style={{
      position: "fixed",
      inset: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "rgba(0,0,0,0.3)",
      zIndex: 1000,
    }}
  >
    <div
      style={{
        background: "#fff",
        width: "650px",
        padding: "30px",
        borderRadius: "20px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        display: "flex",
        flexDirection: "column",
        gap: "25px",
      }}
    >
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2 style={{ fontSize: "22px", fontWeight: "700" }}>VIEW ANNOUNCEMENT</h2>
        <IoCloseOutline
          size={28}
          style={{ cursor: "pointer" }}
          onClick={() => setShowAnnouncepopup(false)}
        />
      </header>

      <hr style={{ borderColor: "#ddd" }} />

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "25px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <label style={{ fontWeight: "600", color: "#16324F" }}>Title</label>
          <div style={{ fontSize: "16px", color: "#222" }}>{selectedRowData.title}</div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <label style={{ fontWeight: "600", color: "#16324F" }}>Target Section</label>
          <div style={{ fontSize: "16px", color: "#222" }}>{selectedRowData.tag}</div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <label style={{ fontWeight: "600", color: "#16324F" }}>Status Tag</label>
          <div style={{ fontSize: "16px", color: "#222" }}>{selectedRowData.status}</div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <label style={{ fontWeight: "600", color: "#16324F" }}>Uploaded File</label>
          {selectedRowData?.fileUrl ? (
  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <span
      style={{
        fontSize: "16px",
        color: "#222",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        maxWidth: "200px",
      }}
    >
      {selectedRowData.fileUrl.substring(
        selectedRowData.fileUrl.lastIndexOf("_") + 1
      )}
    </span>
    <button
      onClick={() =>
    window.open(
      `https://docs.google.com/viewer?url=${selectedRowData.fileUrl}&embedded=true`,
      "_blank"
    )
  }
      style={{
        background: "transparent",
        border: "none",
        color: "#05B8E6",
        fontWeight: "600",
        cursor: "pointer",
        textDecoration: "underline",
      }}
    >
      View
    </button>
  </div>
) : (
  <span style={{ color: "#888" }}>No file uploaded</span>
)}

        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <label style={{ fontWeight: "600", color: "#16324F" }}>Message</label>
        <div style={{ fontSize: "16px", color: "#222" }}>{selectedRowData.message}</div>
      </div>
    </div>
  </div>
)}

        {editAnnouncepopup && selectedAnnouncements && (
  <div
    className="showAnnouncement"
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      alignContent: "center",
      justifyContent: "center",
    }}
  >
    <div
      style={{
        background: "white",
        width: "45%",
        height: "max-content",
        marginTop: "100px",
        padding: "30px",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        borderRadius: "25px",
      }}
    >
      <header style={{ display: "flex", justifyContent: "space-between" }}>
        <h2>UPDATE ANNOUNCEMENT</h2>
        <IoCloseOutline
          size={30}
          onClick={() => {
            setEditAnnouncepopup(false);
            setFile(null);
            setFileError("");
          }}
        />
      </header>
      <hr />

      <div style={{ display: "flex", flexDirection: "column", gap: "50px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "50px" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "15px",
            }}
          >
            <label>Title</label>
            <InputText
              style={{ width: "250px", height: "50px" }}
              name="title"
              value={selectedRowData.title}
              onChange={handleChange}
            />
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "15px",
            }}
          >
            <label>Target Section</label>
            <Dropdown
              style={{ width: "250px", height: "50px" }}
              name="tag"
              value={selectedRowData.tag}
              onChange={(e) => {
                setSelectedPlace(e.value);
                setSelectedRowData((prev) => ({
                  ...prev,
                  tag: e.value,
                }));
              }}
              options={places}
              optionLabel="tag"
              optionValue="tag"
              appendTo="self"
            />
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "15px",
            }}
          >
            <label>Status Tag</label>
            <Dropdown
              style={{ width: "250px", height: "50px" }}
              name="status"
              value={selectedRowData.status}
              onChange={(e) => {
                setStatusTag(e.value);
                setSelectedRowData((prev) => ({
                  ...prev,
                  status: e.value,
                }));
              }}
              options={["active", "inactive"]}
            />
          </div>

          <div
  style={{
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  }}
>
  <label>Upload File (optional)</label>

  <FileUpload
  ref={editFileUploadRef}
  mode="basic"
  name="file"
  accept=".pdf"
  customUpload
  auto={false}
  chooseLabel={
    file
      ? file.name
      : selectedRowData?.fileUrl
      ? selectedRowData.fileUrl.substring(
          selectedRowData.fileUrl.lastIndexOf("_") + 1
        )
      : "Choose File"
  }
  onSelect={(e) => handleFileSelect(e, "edit")}
  style={{
    background: "white",
    border: "1px solid #ccc",
    borderRadius: "10px",
    width: "250px",
    padding: "12px",
    height: "50px",
    display: "flex",
    alignItems: "center",
  }}
  chooseOptions={{
    icon: "pi pi-upload",
    className: "p-button-sm p-button-outlined p-button-secondary",
    style: {
      width: "100%",
      justifyContent: "flex-start",
      color: "#333",
      background: "white",
      border: "none",
      fontWeight: "500",
      height: "100%", 
      borderRadius: "8px",
    },
  }}
/>
  {fileError && (
    <small style={{ color: "red", marginTop: "4px" }}>{fileError}</small>
  )}

</div>

        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          <label>Message</label>
          <InputTextarea
            name="message"
            rows={5}
            cols={30}
            value={selectedRowData.message}
            onChange={handleChange}
            style={{ width: "100%", height: "100px" }}
          />
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          onClick={handleUpdate}
          label="Update"
          style={{
            backgroundColor: "#05B8E6",
            color: "white",
            padding: "10px 40px",
            borderRadius: "25px",
          }}
        />
      </div>
    </div>
  </div>
)}


        <DeletePopup
          visible={showDeletePopup}
          onHide={() => {
            setShowDeletePopup(false);
            setShowCheckboxes(false);
          }}
          onConfirm={() => {
            if (selectedAnnouncements.length > 0) {
              handleDeleteSelected();
            } else {
              handleDeleteSingle(selectedRowData);
            }
          }}
        />
      </div>
    </>
  );
};

export default Announcement;